// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

function DataTableBodyCell({ noBorder, align, children, isSelected, textColor }) {
    return (
        <MDBox
            component="td"
            textAlign={align}
            py={0.8}
            px={3}
            sx={({ palette: { light }, typography: { size }, borders: { borderWidth } }) => ({
                fontSize: size.md,
                borderBottom: noBorder ? "none" : `${borderWidth[1]} solid ${light.main}`,
            })}
        >
            <MDBox
                display="inline-block"
                width="max-content"
                sx={{
                    "& a": { color: textColor || "#344767" }, // <- utilise la couleur passée en prop
                    "&, & *": { fontSize: "0.75rem !important", fontWeight: "light !important" },
                }}
            >
                {children}
            </MDBox>
        </MDBox>
    );
}

// Setting default values for the props of DataTableBodyCell
DataTableBodyCell.defaultProps = {
    noBorder: false,
    align: "left",
    textColor: "#344767",
};

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
    children: PropTypes.node.isRequired,
    noBorder: PropTypes.bool,
    align: PropTypes.oneOf(["left", "right", "center"]),
    textColor: PropTypes.string,
};

export default DataTableBodyCell;

